import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';


@Injectable()
export class PlaceService {
  protected url: string = environment.iCBMSWebApi.url;

  constructor(private http: HttpClient) {}

  getPlaces() {
  return this.http.get(this.url + 'Places');
  }
  listAllPlaces(){
    return this.http.get(this.url + 'list/Places');
  }
  getAllCountryPlaces(id){
    return this.http.get(this.url + 'list/Places/'+id);
  }
  savePlace(body)
  {
    return this.http.post(this.url + 'list/Places',body);
  }
  updatePlace(body)
  {
    return this.http.put(this.url + 'list/Places',body);
  }
  getPlaceById(id){
    return this.http.get(this.url + 'list/Places/find/'+id);
  }
  deletePlace(id){
    return this.http.delete(this.url + 'list/Places/'+id);
  }

  getBorderCrossingsByCountryId(id) {
    return this.http.get(this.url + 'places/borders/' + id);
  }

  getStopsByCountryId(id) {
    return this.http.get(this.url + 'places/stops/' + id);
  }

}
